import type { SVGProps } from "react";

export default function Pen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={1.3}
      {...props}
    >
      <path
        d="M21.1741 6.81189C21.7028 6.28332 21.9998 5.56636 21.9999 4.81875C22 4.07113 21.7031 3.3541 21.1746 2.82539C20.646 2.29668 19.929 1.99961 19.1814 1.99951C18.4338 1.99942 17.7168 2.29632 17.1881 2.82489L3.84206 16.1739C3.60988 16.4054 3.43817 16.6904 3.34206 17.0039L2.02106 21.3559C1.99521 21.4424 1.99326 21.5342 2.01541 21.6217C2.03756 21.7092 2.08298 21.7891 2.14685 21.8529C2.21073 21.9167 2.29068 21.962 2.37821 21.984C2.46575 22.006 2.55762 22.0039 2.64406 21.9779L6.99706 20.6579C7.31023 20.5626 7.59523 20.392 7.82706 20.1609L21.1741 6.81189Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
